import { useTranslation } from 'react-i18next'

import { Toggle } from '@/Atomic/Molecules/Toggle'

interface KanbanViewSwitchProps {
  onSwitchClick: () => void
  active: boolean
}

export const KanbanViewSwitch: React.FC<KanbanViewSwitchProps> = ({
  onSwitchClick,
  active,
}) => {
  const { t } = useTranslation()
  return (
    <div style={{ minWidth: 'fit-content' }}>
      <Toggle
        name="kanban-view"
        data-testid="kanban-view"
        checked={active}
        onChange={onSwitchClick}
        label={t('common.kanbanView')}
      />
    </div>
  )
}
